export const LIGHTSPEED_THEMES = ['patagonia'];
